import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.app.jackpots,
    props.user.user,
    (jackpots, user) => {
        return {
            jackpots: jackpots[user.currency]
        }
    }
)